export enum VirtualCardPermissions {
  Destroy = 'DESTROY',
  Read = 'READ',
  RequestUpdate = 'REQUEST_UPDATE',
  UpdateVirtualCard = 'UPDATE_VIRTUAL_CARD',
  Spend = 'SPEND',
}

export interface VirtualCardPermissionsResponse {
  permissions: VirtualCardPermissions[]
}

export class VirtualCardPermissionsModel {
  public permissions: VirtualCardPermissions[]

  public constructor(data: VirtualCardPermissionsResponse) {
    this.permissions = data.permissions
  }

  public get canRead(): boolean {
    return this.permissions.includes(VirtualCardPermissions.Read)
  }

  public get canReadOnly(): boolean {
    return (
      this.permissions.includes(VirtualCardPermissions.Read) &&
      !this.permissions.includes(VirtualCardPermissions.RequestUpdate) &&
      !this.permissions.includes(VirtualCardPermissions.UpdateVirtualCard) &&
      !this.permissions.includes(VirtualCardPermissions.Spend) &&
      !this.permissions.includes(VirtualCardPermissions.Destroy)
    )
  }

  public get canRequestUpdate(): boolean {
    return this.permissions.includes(VirtualCardPermissions.RequestUpdate)
  }

  public get canUpdateVirtualCard(): boolean {
    return this.permissions.includes(VirtualCardPermissions.UpdateVirtualCard)
  }

  public get canSpend(): boolean {
    return this.permissions.includes(VirtualCardPermissions.Spend)
  }
}
